//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Goldman_Index',
  data() {
    return {
      form: {
        age: '0',
        myocardial_infarct: '0',
        vasc: '0',
        diab: '0',
        prior: '0',
        five:'0',
        arterial_surgery:'0',
        emergency_operation:'0'
      },
      otherForm:{
        PaO2:'0',
        k:'0',
        HCO3:'0',
        BUN:'0',
        GOT:'0',
        liver_disease:'0',
        bedridden:'0',
      },

      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let otherForm = JSON.parse(JSON.stringify(self.otherForm))
      let flag = true
      let num = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      for (const key in otherForm) {
        if (otherForm.hasOwnProperty(key)) {
          console.log(otherForm[key],'在这里');
          if (otherForm[key] !=0) {
            num = 3
          } 
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        let result = (form.age ? 5:0) +
        (form.myocardial_infarct ? 10 :0) +
        (form.vasc ? 11 :0) +
        (form.diab ? 3 :0) +
        (form.prior ? 7 :0) +
        (form.five ? 7 :0) +
        num+
        (form.arterial_surgery ? 3 :0) +
        (form.emergency_operation ? 4 :0) 
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Goldman_Index.vue